<template>
  <div>
    <el-dialog
      title="添加门店"
      :visible.sync="showShop"
      class="top-draft-dialog"
      :before-close="handleClose"
    >
      <div class="card">
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px;" class="font-size-16">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col" class="w-300">门店名称</th>
                  <th scope="col">门店地址</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="font-size-16">
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">{{ item.name }}</td>
                  <td>{{ item.address || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <pagination ref="page" @pageCallback="pageCallback"></pagination>
        <app-list-loading ref="loading"></app-list-loading>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import shop from "../../../server/api/shop";
import pagination from "@/components/pagination/pagination.vue";

export default {
  components: {
    pagination,
  },

  data() {
    return {
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        contentKeyword: null,
        page: 1,
        pageSize: 10,
      },
      items: [],
      showShop: false,
    };
  },
  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },
  props: {},

  mounted() {},

  methods: {
    showModel() {
      this.resetParams();
      this.choiceListIds = [];
      this.allListIds = [];
      this.indeterminate = false;
      this.showShop = true;
    },

    handleClose() {
      this.showShop = false;
    },
    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },
    //获取列表数据
    getList() {
      let params = this.utils.getQuery(this.pageParams);
      // this.$refs.loading.show()
      this.items = [];
      shop.list(params).then((resp) => {
        if (resp.data) {
          if (this.$refs.loading) {
            this.$refs.loading.hide(resp.data.items);
          }

          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
              if (this.$refs.page) {
                this.$refs.page.setPages(pages);
              }
            });
          }
        }
      });
    },

    submitCreate() {
      let shops = [];
      if (this.choiceListIds) {
        this.items.forEach((item) => {
          if (this.choiceListIds.indexOf(item.id) >= 0) {
            shops.push(item);
          }
        });
      }
      let current = {
        code: "shop",
        item: shops,
      };
      this.handleClose();
      this.$emit("pageCallback", current);
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //重置搜索参数
    resetParams() {
      this.pageParams = {
        contentKeyword: null,
        page: 1,
        pageSize: 10,
      };
      this.getList();
    },
  },
};
</script>
